import { UseMutationResult } from '@tanstack/react-query';

import { getOutstandingResponsesReportCsv, useBaseReportCsv } from 'api';

export const useOutstandingResponsesReportCsv = (): UseMutationResult<Blob> =>
  useBaseReportCsv(getOutstandingResponsesReportCsv);
